import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "@/App";
import router from "@/router"; // api: https://github.com/vuejs/vue-router
import store from "@/store"; // api: https://github.com/vuejs/vuex
import VueCookie from "vue-cookie"; // api: https://github.com/alfhen/vue-cookie
import "@/element-ui"; // api: https://github.com/ElemeFE/element
// import elementUI from 'element-ui'  // api: https://github.com/ElemeFE/element
import "@/icons"; // api: http://www.iconfont.cn/
import "@/element-ui-theme";
import "@/assets/less/index.less";
import "element-ui/lib/theme-chalk/index.css";
import httpRequest from "@/utils/httpRequest"; // api: https://github.com/axios/axios
import {
  tabsCloseAllHandle,
  tabsCloseCurrentHandle,
  tabsRefreshCurrentHandle,
} from "@/utils/routeTab";
import {
  addMonth,
  formatDate,
  formatterDataDictionary,
  formatterTagType,
  getFullMonth,
  getMonth,
  getYear,
  iframeInsert,
  isIEBrowser,
  parseToDate,
} from "@/utils";
import { AddSeal, OpenFile, SaveToS } from "@/utils/pmCA";
import { initMenuList } from "@/router/index";
import { message } from "@/utils/resetMessage";
import { hasBtnPermission, isAuth } from "@/utils/login";
import cloneDeep from "lodash/cloneDeep";
import echarts from "echarts";
import VueQuillEditor from "vue-quill-editor";
import flowChart from "@/components/flowChart";
import rightNav from "@/components/componentNav";
import choiceCity from "@/components/choiceCity";
import docPop from "@/components/docPop";
import * as filters from "./filter/index";
import "./directives/index";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import md5 from "js-md5";
import { Button, Steps, Icon } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import { mouseIn, mouseOut } from "./utils/index";
import {getSetting} from '@/utils/lui'
const bus = new Vue();
import print from "./utils/print.js";

Vue.use(print);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Steps);
Vue.prototype.$settings=getSetting();
Vue.prototype.mymouseIn = mouseIn;
Vue.prototype.mymouseOut = mouseOut;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
// import vRegion from 'v-region';
// Vue.use(vRegion);
Vue.use(VueQuillEditor /* { default global options } */);

Vue.prototype.$echarts = echarts;
Vue.use(VueCookie);
// Vue.use(elementUI)
Vue.config.productionTip = false;
// 非生产环境, 适配mockjs模拟数据                 // api: https://github.com/nuysoft/Mock
if (process.env.NODE_ENV !== "production") {
  require("@/mock");
}

import customform from 'pm-customform-std-ui-plus';
import 'pm-customform-std-ui-plus/lib/PmCustomformStdUi.css';
const adornUrl = (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '' : process.env.VUE_APP_proxybaseurl)
Vue.use(customform, {
  adornUrl,
  handleReplaceText: true, //支持错词、敏感词处理
  showHistoryConfig: true, //如需支持 产品化历史变更功能
})

Vue.component("flowChart", flowChart);
Vue.component("rightNav", rightNav);
Vue.component("choiceCity", choiceCity);
Vue.component("docPop", docPop);

// 挂载全局
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.hasBtnPermission = hasBtnPermission; // btn权限方法
Vue.prototype.parseToDate = parseToDate;
Vue.prototype.isIEBrowser = isIEBrowser;
Vue.prototype.iframeInsert = iframeInsert;
Vue.prototype.getMonth = getMonth;
Vue.prototype.getYear = getYear;
Vue.prototype.formatDate = formatDate;
Vue.prototype.addMonth = addMonth;
Vue.prototype.getFullMonth = getFullMonth;
Vue.prototype.tabsCloseCurrent = tabsCloseCurrentHandle;
Vue.prototype.tabsCloseAllHandleCurrent = tabsCloseAllHandle;
Vue.prototype.tabsRefreshCurrent = tabsRefreshCurrentHandle;
Vue.prototype.OpenFile = OpenFile;
Vue.prototype.AddSeal = AddSeal;
Vue.prototype.SaveToS = SaveToS;
Vue.prototype.initMenuList = initMenuList;
Vue.prototype.formatterTagType = formatterTagType;
Vue.prototype.formatterDataDictionary = formatterDataDictionary;
Vue.prototype.$message = message;
Vue.prototype.$md5 = md5;
Vue.prototype.$bus = bus;

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG["storeState"] = cloneDeep(store.state);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
